import React, { useLayoutEffect, useRef, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png";
import navbarCloseIcon from "../assets/images/navbar-close-icon.svg";
import dashboard from "../assets/images/dashboard.svg";
import managestudents from "../assets/images/managestudents.svg";
import manageattorney from "../assets/images/manageattorney.svg";
import managecourse from "../assets/images/managecourse.svg";
import Report from "../assets/images/ReportImage.svg";
import clientcards from "../assets/images/clientcards.svg";
import training from "../assets/images/training.svg";
import language from "../assets/images/language.svg";
import evaluation from "../assets/images/evaluation.svg";
import certificates from "../assets/images/certificates.svg";
import pending from "../assets/images/pending.svg";

const menuGroups = {
  "Manage Courses": [["Evaluation Stats (CC)", "/evaluationstats1stcourse"], ["Evaluation Stats (DE)", "/evaluationstats2ndcourse"]],
  Reports: [["Completion Report", "/completionreport"], ["Fee waiver Report", "/freewavierreport"], ["Language Report", "/languagereport"], ["Survey Report", "/surveyreport"], ["Certificate Issued", "/certificate-issued"], ["Retake Report", "/retakereport"]],
  "Pending Billing": [["Billing", "/attorneypendingbilling?course=all"], ["Invoice History", "/attorneyinvoicehistory"]],
};

// Admin pages remount the sidebar, so keep its navigation state between instances.
let savedScrollTop = 0;
let savedOpenGroups = {};

const DashBoardSidebar = () => {
  const { pathname } = useLocation();
  const sidebarRef = useRef(null);
  const activeGroup = Object.keys(menuGroups).find((group) =>
    menuGroups[group].some(([, url]) => url.split("?")[0] === pathname)
  );
  const [openGroups, setOpenGroups] = useState(() => ({
    ...savedOpenGroups,
    ...(activeGroup ? { [activeGroup]: true } : {}),
  }));

  useLayoutEffect(() => {
    if (activeGroup) {
      savedOpenGroups = { ...savedOpenGroups, [activeGroup]: true };
      setOpenGroups((current) => ({ ...current, [activeGroup]: true }));
    }
  }, [activeGroup, pathname]);

  useLayoutEffect(() => {
    const sidebar = sidebarRef.current;
    sidebar.scrollTop = savedScrollTop;
    const selected = sidebar.querySelector('a[aria-current="page"]');
    if (selected) {
      const bounds = sidebar.getBoundingClientRect();
      const item = selected.getBoundingClientRect();
      // Reveal clipped links within this pane without scrolling the document.
      if (bounds.height > 0 && item.height > 0) {
        if (item.top < bounds.top) sidebar.scrollTop -= bounds.top - item.top + 12;
        else if (item.bottom > bounds.bottom) sidebar.scrollTop += item.bottom - bounds.bottom + 12;
      }
    }
    savedScrollTop = sidebar.scrollTop;
  }, [pathname, openGroups]);

  const toggleGroup = (group) => {
    savedScrollTop = sidebarRef.current.scrollTop;
    setOpenGroups((current) => {
      const next = { ...current, [group]: !current[group] };
      savedOpenGroups = next;
      return next;
    });
  };

  const tabs = [
    {
      label: "Dashboard",
      link: "/admin-dashboard",
      img: dashboard,
    },
    {
      label: "Manage Students",
      link: "/managestudents",
      img: managestudents,
    },
    {
      label: "Manage Attorneys",
      link: "/manageattorney",
      img: manageattorney,
    },
    {
      label: "Manage Staff Account",
      link: "/managestaff",
      img: manageattorney,
    },
    {
      label: "Manage Courses",
      img: managecourse,
    },
    {
      label: "Reports",
      img: Report,
    },
    {
      label: "Certificates",
      link: "/certificates",
      img: certificates,
    },
    {
      label: "Client Card Orders",
      link: "/clientcardsorders",
      img: clientcards,
    },
    {
      label: "Training and How-to",
      link: "/trainingandhowto",
      img: training,
    },
    {
      label: "Language requests",
      link: "/languagerequests",
      img: language,
    },

    // {
    //   label: "Attorney Email Addresses",
    //   link: "/attorneyemailaddress",
    //   img: img3,
    // },
    {
      label: "Pending Billing (CC)",
      link: "/pendingbilling1stcourse",
      img: pending,
    },
    {
      label: "Pending Billing (DE)",
      link: "/pendingbilling2ndcourse",
      img: pending,
    },
    {
      label: "Pending Billing",
      img: managecourse,
    },
    // {
    //   label: "Enrollment Stats (1st Course)",
    //   link: "/enrollmentstats1stcourse",
    //   img: img2,
    // },
    // {
    //   label: "Enrollment Stats (2nd Course)",
    //   link: "/enrollmentstats2ndcourse",
    //   img: img1,
    // },
    // {
    //   label: "Budget Analysis",
    //   link: "/404",
    //   img: img1,
    // },
    // {
    //   label: "Budget Analysis PDF",
    //   link: "/404",
    //   img: img3,
    // },
    // {
    //   label: "Certificates",
    //   link: "/certificates",
    //   img: img3,
    // },
    // {
    //   label: "Booklets and Certs to Mail",
    //   link: "/booklets",
    //   img: img2,
    // },
  ];

  return (
    <div>
      <nav id="sidebar" ref={sidebarRef} aria-label="Admin navigation"
        onScroll={(event) => { savedScrollTop = event.currentTarget.scrollTop; }}
        onClickCapture={() => { savedScrollTop = sidebarRef.current.scrollTop; }}>
        <div className="sidebar-header">
          <div className="logo_Wrap">
            <Link className="logo_hover" to="/"><img src={logo} alt="Evergreen" /></Link>
          </div>
          <div className="navbar_header mb_show_cross">
            <button type="button" id="sidebarCollapse_close" className="close_btn" aria-label="Close navigation"
              onClick={() => { sidebarRef.current.style.marginLeft = "-325px"; }}>
              <img src={navbarCloseIcon} alt="" className="close_btn" />
            </button>
          </div>
        </div>
        <ul className="list-unstyled components adminSidebar">
          {tabs.map((tab) => {
            const children = menuGroups[tab.label];
            const groupId = "admin-menu-" + tab.label.toLowerCase().replaceAll(" ", "-");
            return children ? (
              <li className="dropdown" key={tab.label}>
                <button className={"btn btn-secondary dropdown-toggle manageCourse" + (activeGroup === tab.label ? " admin-menu-group-active" : "")}
                  type="button" id={groupId + "-toggle"} aria-controls={groupId}
                  aria-expanded={Boolean(openGroups[tab.label])} onClick={() => toggleGroup(tab.label)}>
                  <img style={{ marginRight: "12px" }} src={tab.img} alt="" />{tab.label}
                </button>
                <ul id={groupId} className={"dropdown-menu admindrop" + (openGroups[tab.label] ? " show" : "")}
                  aria-labelledby={groupId + "-toggle"}>
                  {children.map(([label, url]) => (
                    <li key={url}><NavLink to={url} className="dropdown-item"><img src={evaluation} alt="" />{label}</NavLink></li>
                  ))}
                </ul>
              </li>
            ) : (
              <li key={tab.link}><NavLink to={tab.link}><img src={tab.img} alt="" /> {tab.label}</NavLink></li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default DashBoardSidebar;
